angular.module('content.widgets.ContentWidgetController', [
  'content.widgets.ContentWidgetService'
])

/**
 * The ContentWidgetController manages scope logic and user
 * interaction.
 *
 * @class ContentWidgetController
 * @constructor
 * @module content.widgets.ContentWidgetController
 **/
.controller('ContentWidgetController', [
  '$scope',
  '$state',
  '$sce',
  'ContentWidgetService',
  'StatesService',
  'SimulationService',
  'EventsWidgetService',
  function (
    $scope,
    $state,
    $sce,
    ContentWidgetService,
    StatesService,
    SimulationService,
    EventsWidgetService
  ) {
    'use strict';

    $scope.formattedModel = {};

    $scope.state = {
      selected: null,
      breadcrumbs: [],
      list: [],
      media: []
    };

    $scope.submit = function (button) {
      $scope.processing = true;

      return EventsWidgetService
        .process($state.params.stateId, 'content', button.id)
        .then(function (response) {
          SimulationService.addToDisabled($state.params.stateId);
          StatesService.goToState(response.content.feedback.targetId);
          return;
        })
        .catch(function (err) {
          console.log(err);
        });
    };


    /**
     * Returns the model captured from edit mode
     *
     * @return {Object} Widget instance model
     */
    $scope.getModel = function getModel() {
      return ContentWidgetService.getModel($scope.model, $scope.form.model);
    };

    /**
     * Method executes the initialization process.
     *
     * @private
     */
    function initialize() {
      // emits an event passing the current scope.  This scope is picked up by the
      // associated theme to register as the active scope.
      // This event is required to initialize a widget
      $scope.$emit('setCurrentContentScope', $scope);

      $scope.formattedModel = {
        title: $scope.model.label,
        stem: $sce.trustAsHtml($scope.model.content.decisions.content.stem),
        choices: $scope.model.content.decisions.content.choices,
        media: $scope.model.content.decisions.content.media
      };

      if (!_.isArray($scope.model.content.rules)) {
        $scope.form = ContentWidgetService.configureForm($scope.model);
      }
    }

    initialize();
  }
]);
